import React, { useEffect } from "react"
import "./chat.scss"

const Chat = () => {
  const haveChat = ["es-CO", "es-PR"]

  const initESW = function(gslbBaseURL) {
    window.embedded_svc = window.embedded_svc || []
    window.embedded_svc.settings.displayHelpButton = true //O falso
    window.embedded_svc.settings.language = "ES" //Por ejemplo, introduzca 'en' o 'en-US'
    window.embedded_svc.settings.defaultMinimizedText = process.env.LOCALE === "es-CO" ? "Chat en línea" : "Chat con un asesor" //(Toma como valor predeterminado SesiÃ³n de chat con un experto)
    window.embedded_svc.settings.disabledMinimizedText = "Asesor sin conexión" //(Toma como valor predeterminado Agente sin conexiÃ³n)
    window.embedded_svc.settings.loadingText = "Cargando" //(Toma como valor predeterminado Cargando)
    //window.embedded_svc.settings.storageDomain = 'yourdomain.com'; //(Establece el dominio para su desarrollo de modo que los visitantes puedan navegar por subdominios durante una sesiÃ³n de chat)

    // ConfiguraciÃ³n para Chat
    //window.embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
    // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
    // Returns a valid button ID.
    //};
    //window.embedded_svc.settings.prepopulatedPrechatFields = {}; //Establece la cumplimentaciÃ³n automÃ¡tica de los campos del formulario previo al chat
    //window.embedded_svc.settings.fallbackRouting = []; //Una matriz de identificadores de botones, de usuario o userId_buttonId
    //window.embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Toma como valor predeterminado la opciÃ³n Contacto)

    window.embedded_svc.settings.enabledFeatures = ["LiveAgent"]
    window.embedded_svc.settings.entryFeature = "LiveAgent"

    window.embedded_svc.init(
      "https://grupofamilia.my.salesforce.com",
      "https://grupofamilia.secure.force.com",
      gslbBaseURL,
      "00D3j0000001yNQ",
      "GRF_B2CNosotras",
      {
        baseLiveAgentContentURL:
          "https://c.la4-c3-ia2.salesforceliveagent.com/content",
        deploymentId: "5723j000000TWp0",
        buttonId: "5733j000000TXBd",
        baseLiveAgentURL: "https://d.la4-c3-ia2.salesforceliveagent.com/chat",
        eswLiveAgentDevName: "GRF_B2CNosotras",
        isOfflineSupportEnabled: false,
      }
    )
  }

  React.useEffect(() => {
    if (haveChat.includes(process.env.LOCALE)) {
      if (!window.window.embedded_svc) {
        var s = document.createElement("script")
        s.setAttribute(
          "src",
          "https://grupofamilia.my.salesforce.com/embeddedservice/5.0/esw.min.js"
        )
        s.onload = function() {
          initESW(null)
        }
        document.body.appendChild(s)
      } else {
        initESW("https://service.force.com")
      }
    }
  }, [])

  useEffect(() => {
    if (process.env.LOCALE === "es-PR") {
      let count = 0
      let idInterval = setInterval(() => {
        count++
        if (document.getElementsByClassName("helpButton").length > 0) {
          document
            .getElementsByClassName("helpButton")[0]
            .classList.add("f-chat-pr")
          clearInterval(idInterval)
        }
        if (count > 30) clearInterval(idInterval)
      }, 500)
    }
  }, [])

  return <></>
}

export default Chat
